import { BalSpinner, BalText } from "@baloise/ds-react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import React from "react";

import { LoadingOverlayProps } from "./loadingOverlay.types";
import * as style from "./loadingoverlay.module.scss";

/**
 * loadingOverlay
 */
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
    msg = "createlead.loading",
}) => {
    const { t } = useTranslation();
    return (
        <>
            <div
                className={`${style.overlay} flex align-items-center justify-content-center flex-direction-column`}
            >
                <BalSpinner color="white" />
                <BalText color="white" size="lead">
                    {t(msg)}
                </BalText>
            </div>
            <div className={`${style.overlaybackdrop}`}></div>
        </>
    );
};

export default LoadingOverlay;
